// extracted by mini-css-extract-plugin
export default {"root":"IconOvenMitts_root__0+gLq"};